import { PartnerCreateModelInterface } from "@api/models/interfaces/exhibition/PartnerCreateModelInterface";
import { MultiLangObjectModel } from "../common/MultiLangObjectModel";
import { AppercodeFile } from "../File";

const copy = ((): { value: string | null } => ({ value: null }))()

export class PartnerCreateModel extends MultiLangObjectModel implements PartnerCreateModelInterface {
    iconFile?: AppercodeFile | File;
    parentId = "";
    title: string;
    userProfileIds?: string[];
    tagsIds?: string[];
    ownerIds?: number[];
    eventId = "";

    $_multiLangFields = [
        'title'
    ];

    constructor(languages: string[], eventId: string) {
        super();

        const res: { [key: string]: any } = {
            eventId
        };

        this.$_multiLangFields.forEach((field) => {
            languages.forEach((lang) => res[`${field}.${lang}`] = "")
        })

        Object.assign(this, res)

        this.resetCopy();
    }

    get needReset() {
        return JSON.stringify(this) !== copy.value;
    }

    resetCopy() {
        copy.value = JSON.stringify(this);
    }
}
